import React from "react";

const FormErrors = ({ submitError, dirtySinceLastSubmit }) =>
  submitError && !dirtySinceLastSubmit ? (
    <div className="form-group">
      {dirtySinceLastSubmit}
      <div className="invalid-feedback">{submitError}</div>
    </div>
  ) : null;

export { FormErrors };
